import { Component, Input, ViewChild, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { AdminService } from '../../shared/services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { SideMenuNode } from '../../shared/components/sidemenu/sidemenu.model';
import { InbuiltEditorComponent } from '../../shared/components/inbuilt-editor/inbuilt-editor.component';

@Component({
  selector: 'app-add-new-report',
  templateUrl: './add-new-report.component.html',
  styleUrl: './add-new-report.component.css',
  standalone: false
})
export class AddNewReportComponent implements OnChanges {
  @Input() reportTypes: string[] = [];
  @ViewChild('addReportPopup') addReportPopup: any;
  @ViewChild(InbuiltEditorComponent) inbuiltEditor?: InbuiltEditorComponent;
  @Input('reportCategoryList') reportCategoryList: Array<string> = [];
  showMenu = false;
  selectedReportType = '';
  dataToEdit: any = {};
  closePopup = false;
  editFlag = false;
  tableName = 'REPORT_MANAG';
  isAddReportPopupOpen = false;
  // True only when the Json-Editor side-menu tab is actually shown (edit mode with a pre-existing inbuilt_report_json).
  showJsonEditorTab = false;
  readOnly = false;

  menuItems: SideMenuNode[] = [
    { id: 'template', type: 'template', name: 'Template' },
    { id: 'json-editor', type: 'editor', name: 'Json-Editor' }
  ];

  defaultInbuiltJson: any = {
    pages: {
      page_one: {
        name: 'Page 1',
        order: 1,
        tabs: {
          default: {
            name: '',
            order: 1,
            elements: []
          }
        }
      }
    }
  };

  reportJson: any = {};
  // Live text emitted from the json-editor on every keystroke; kept separate from
  // reportJson so it never flows back into [initialJson] (that would re-trigger
  // JsonEditorComponent's ngOnChanges and overwrite the model mid-edit).
  currentReportJsonText: any = '';

  formfields: any[] = [
    { label: 'Report', inputType: 'text', fcname: 'Report', placeholder: 'Enter Report', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Report Id', inputType: 'text', fcname: 'Report_Id', placeholder: 'Report Id', dropdownData: null, dependentField: ['Report_Type', 'Embed_type'], depFieldVal: ['Power BI', 'Web'], mandCheck: ['equal', 'equal'] },
    { label: 'Report Type', inputType: 'text', fcname: 'Report_Type', placeholder: 'Enter Report Type', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Internal Report', inputType: 'yesnoradio', fcname: 'internal_Report', placeholder: null, dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Report Link', inputType: 'textarea', fcname: 'Report_Link', dependentField: ['Report_Type'], depFieldVal: ['power bi'], mandCheck: ['notEqual'], placeholder: '', dropdownData: null },
    { label: 'Report Description', inputType: 'textarea', fcname: 'Description', placeholder: '', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Documentation', inputType: 'textarea', fcname: 'Documentation', placeholder: '', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Image', inputType: 'text', fcname: 'Image', placeholder: 'Image', dropdownData: null, dependentField: ['Page_name'], depFieldVal: ['Workforce'], mandCheck: ['equal'] },
    { label: 'Access Restricted', inputType: 'yesnoradio', fcname: 'Access_Restricted', placeholder: null, dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Access Restriction Link', inputType: 'textarea', fcname: 'Access_Restriction_link', placeholder: '', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Category', inputType: 'text', fcname: 'Category', placeholder: 'Enter Category', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Category Rank', inputType: 'number', fcname: 'Category_rank', placeholder: 'Enter Category rank', dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Embed', inputType: 'yesnoradio', fcname: 'EMbed', placeholder: null, dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Embed Link', inputType: 'textarea', fcname: 'Embed_link', placeholder: '', dropdownData: null, dependentField: ['Report_Type', 'Embed_type'], depFieldVal: ['Power BI', 'Iframe'], mandCheck: ['equal', 'equal'] },
    { label: 'Embed Type', inputType: 'singleSelect', fcname: 'Embed_type', placeholder: 'Select Embed type', dropdownData: ['Iframe', 'Web'], dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Managed By', inputType: 'singleSelect', fcname: 'Managedby', placeholder: 'Select Managed by', dropdownData: ['TechOps', 'Workforce'], dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Secure', inputType: 'yesnoradio', fcname: 'Secure', placeholder: null, dropdownData: null, dependentField: ['Access_Restricted'], depFieldVal: ['Yes'], mandCheck: ['equal'] },
    { label: 'Secure Check', inputType: 'text', fcname: 'Secure_Check', placeholder: 'Enter Secure Check', dropdownData: null, dependentField: ['Access_Restricted'], depFieldVal: ['Yes'], mandCheck: ['equal'] },
    { label: 'Secure Group', inputType: 'text', fcname: 'Secure_group', placeholder: 'Enter Secure Group', dropdownData: null, dependentField: ['Access_Restricted'], depFieldVal: ['Yes'], mandCheck: ['equal'] },
    { label: 'Page Name', inputType: 'singleSelect', fcname: 'Page_name', placeholder: 'Select Page name', dropdownData: ['Reports', 'Workforce'], dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Has Owner', inputType: 'yesnoradio', fcname: 'HasOwner', placeholder: null, dropdownData: null, dependentField: null, depFieldVal: null, mandCheck: null },
    { label: 'Owner Details', inputType: 'text', fcname: 'ownerDetails', placeholder: 'Enter Owner Details', dropdownData: null, dependentField: ['HasOwner'], depFieldVal: ['Yes'], mandCheck: ['equal'] }
  ];
  @Output() callReportAPI: EventEmitter<any> = new EventEmitter();

  constructor(private adminService: AdminService, private toastr: ToastrService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.reportTypes && this.reportTypes.length > 0) {
      this.reportTypes = this.reportTypes.sort((a, b) => a.localeCompare(b));
    }
    if (this.reportCategoryList && this.reportCategoryList.length > 0) {
      const categoryField = this.formfields.find(f => f.fcname === 'Category');
      if (categoryField) {
        categoryField.dropdownData = this.reportCategoryList;
      }
    }
  }

  selectReportType(type: string): void {
    this.selectedReportType = type;
    this.showMenu = false;
    this.dataToEdit = {};
    this.editFlag = false;
    this.closePopup = false;
    this.isAddReportPopupOpen = true;
    this.reportJson = JSON.parse(JSON.stringify(this.defaultInbuiltJson));
    this.currentReportJsonText = '';
    const categoryField = this.formfields.find(f => f.fcname === 'Category');
    if (categoryField && this.reportCategoryList?.length > 0) {
      categoryField.dropdownData = this.reportCategoryList;
    }
    // Add flow: template only — no side menu, no Json-Editor tab, no JSON validation on save.
    this.showJsonEditorTab = false;
    this.menuItems = [
      { id: 'template', type: 'template', name: 'Template' }
    ];
    this.addReportPopup?.show();
  }

  /** Opens the same Add Report popup (Template + Json-Editor) pre-filled from an existing report for editing. */
  editReport(report: any): void {
    this.selectedReportType = report?.Report_Type || '';
    this.showMenu = false;
    this.dataToEdit = report || {};
    this.editFlag = true;
    this.closePopup = false;
    this.isAddReportPopupOpen = true;
    const rawJson = report?.inbuilt_report_json;
    const existingJson = typeof rawJson === 'string' && rawJson.trim() ? this.safeParseJson(rawJson) : rawJson;
    const hasExistingJson = !!existingJson && Object.keys(existingJson).length > 0;
    this.reportJson = hasExistingJson
      ? JSON.parse(JSON.stringify(existingJson))
      : JSON.parse(JSON.stringify(this.defaultInbuiltJson));
    this.currentReportJsonText = '';
    const categoryField = this.formfields.find(f => f.fcname === 'Category');
    if (categoryField && this.reportCategoryList?.length > 0) {
      categoryField.dropdownData = this.reportCategoryList;
    }
    // Only show the Json-Editor side-menu tab when the report already has inbuilt_report_json defined.
    this.showJsonEditorTab = hasExistingJson;
    this.readOnly = true;
    this.menuItems = hasExistingJson
      ? [
          { id: 'template', type: 'template', name: 'Template' },
          { id: 'json-editor', type: 'editor', name: 'Json-Editor' }
        ]
      : [
          { id: 'template', type: 'template', name: 'Template' }
        ];
    this.addReportPopup?.show();
  }

  closeModal(): void {
    // app-modal already emits closeModal from its own hide(); calling hide() again here
    // re-triggers this handler and recurses infinitely (Maximum call stack size exceeded).
    this.isAddReportPopupOpen = false;
    this.closePopup = true;
    setTimeout(() => { this.closePopup = false; }, 100);
  }

  private safeParseJson(value: string): any {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  isReportTypeInbuilt(type: string): boolean {
    const t = (type || '').toLowerCase();
    return t === 'inbuilt' || t === 'pre_defined_extract';
  }

  onJsonTextChange(ev: any): void {
    this.currentReportJsonText = ev;
  }

  /** True once the Json-Editor tab's content differs from its baseline; only meaningful when that tab is shown. */
  get isJsonChanged(): boolean {
    return this.showJsonEditorTab ? !!this.inbuiltEditor?.isJsonChanged : false;
  }

  onReportSubmit(event: any): void {
    this.addReportPopup?.hide();
    // Editing an existing report must keep its id so the backend updates it instead of
    // creating a duplicate; the "Add Report" flow never has editFlag set, so id is stripped there.
    if (!this.editFlag){
      delete event.payload.id;
    }
    if (this.isReportTypeInbuilt(this.selectedReportType)) {
      const latestJson = this.currentReportJsonText || this.reportJson;
      event.payload.inbuilt_report_json = typeof latestJson === 'string' ? latestJson : JSON.stringify(latestJson);
    }
    if(this.editFlag)
      this.adminService.updateReports(event.payload).subscribe({
        next: (response: any) => {
          this.toastr.success(response?.msg || 'Report updated successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
          this.callReportAPI.emit(true);
        },
        error: (err: any) => {
          this.toastr.error(err?.message || 'Error updating report', '', { timeOut: 5000, positionClass: 'toast-top-center' });
          this.callReportAPI.emit(false);
        }
      });
    else
      this.adminService.addReports(event.payload).subscribe({
      next: (response: any) => {
        this.toastr.success(response?.msg || 'Report added successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        this.callReportAPI.emit(true);
    },
      error: (err: any) => {
        this.toastr.error(err?.message || 'Error adding report', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        this.callReportAPI.emit(false);
    }
    });
  }
}
